export default __webpack_public_path__ + "static/media/isr_logo.e0c41844.png";